<script lang="ts" module>
	import type { TxtVariant } from '../Txt';

	export interface DisclosureProps {
		dataCy: string;
		// The plain-text label; `labelSlot` replaces it when the label needs markup.
		label?: string;
		labelSlot?: import('svelte').Snippet;
		labelVariant?: TxtVariant;
		open?: boolean;
		class?: string;
		classes?: {
			summary?: string;
			label?: string;
			content?: string;
		};
		children?: import('svelte').Snippet;
	}
</script>

<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { Txt } from '../Txt';

	let {
		dataCy,
		label = '',
		labelSlot,
		labelVariant = 'body2',
		open = $bindable(false),
		classes = {},
		children,
		...rest
	}: DisclosureProps = $props();
</script>

<!-- A native disclosure: closed by default, toggled by the summary, no JS.
`list-none` drops the browser marker in favour of the triangle, which turns
when open. -->
<details class={twMerge('group', rest.class)} data-cy={dataCy} bind:open>
	<summary
		class={twMerge(
			'flex cursor-pointer list-none items-center gap-2 [&::-webkit-details-marker]:hidden',
			classes.summary
		)}
		data-cy={`${dataCy}-summary`}
	>
		<svg
			aria-hidden="true"
			viewBox="0 0 8 8"
			class="h-2 w-2 shrink-0 fill-current transition-transform group-open:rotate-90"
		>
			<path d="M1 0l6 4-6 4z" />
		</svg>
		{#if labelSlot}
			{@render labelSlot()}
		{:else}
			<Txt component="span" variant={labelVariant} class={twMerge('underline', classes.label)}>
				{label}
			</Txt>
		{/if}
	</summary>
	<div class={twMerge('mt-6', classes.content)} data-cy={`${dataCy}-content`}>
		{@render children?.()}
	</div>
</details>
